import React from 'react';
import classes from './textarea.module.scss';

const TextArea = ({ error, label, ...rest }: any) => {
  const textAreaClasses = [classes.textArea];
  if (error) {
    textAreaClasses.push(classes.error);
  }

  return (
    <div className={classes.fieldContainer}>
      <label>
        <span className={classes.labelText}>{label}</span>
        <textarea className={textAreaClasses.join(' ')} {...rest} />
      </label>
      {error && (
        <p
          data-e2e-id={`${name}-errorMessage`}
          className={classes.errorMessage}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default TextArea;
